import { FC } from "react";

import type { TBannersProps } from "../types";
import Banners from "./Banners";

const BannersLanding: FC<TBannersProps> = ({ bannersData }) => <Banners bannersData={bannersData} />;
export default BannersLanding;
